"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var ForecastSimulationUpdateDTO_1 = require("../model/ForecastSimulationUpdateDTO");

var ForecastSimulationUpdateDTOConverter_1 = require("./ForecastSimulationUpdateDTOConverter");
/**
 * @author PKr
 */


var ForecastSimulationUpdateDTOConverterImpl =
/*#__PURE__*/
function (_ForecastSimulationUp) {
  _inherits(ForecastSimulationUpdateDTOConverterImpl, _ForecastSimulationUp);

  function ForecastSimulationUpdateDTOConverterImpl() {
    _classCallCheck(this, ForecastSimulationUpdateDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationUpdateDTOConverterImpl).apply(this, arguments));
  }

  _createClass(ForecastSimulationUpdateDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ForecastSimulationUpdateDTO_1.ForecastSimulationUpdateDTO(this.valueOrUndefined(source, 'actionType', function (value) {
        return conversions.asEnum(value, ForecastSimulationUpdateDTO_1.ForecastSimulationUpdateTypeEnum);
      }), this.valueOrUndefined(source, 'windowId'), this.valueOrUndefined(source, 'windowItemId'), this.valueOrUndefined(source, 'supplierAgreementId'), this.valueOrUndefined(source, 'windowTypeId'), this.valueOrUndefined(source, 'windowTypeNote'), this.valueOrUndefined(source, 'windowName'), this.valueOrUndefined(source, 'windowNameNote'), this.valueOrUndefined(source, 'regularPrice', source.regularPrice ? conversions.toBigNumber : null), this.valueOrUndefined(source, 'regularPriceNote'), this.valueOrUndefined(source, 'promoPrice', source.promoPrice ? conversions.toBigNumber : null), this.valueOrUndefined(source, 'promoPriceNote'), this.valueOrUndefined(source, 'promoVolume', source.promoVolume ? conversions.toBigNumber : null), this.valueOrUndefined(source, 'promoVolumeNote'), this.valueOrUndefined(source, 'posMarginImpactTheoretical', source.posMarginImpactTheoretical ? conversions.toBigNumber : null), this.valueOrUndefined(source, 'posMarginImpactTheoreticalNote'), this.valueOrUndefined(source, 'posMechanics'), this.valueOrUndefined(source, 'posMechanicsNote'), this.valueOrUndefined(source, 'promoPurchasePrice', source.promoPurchasePrice ? conversions.toBigNumber : null), this.valueOrUndefined(source, 'promoPurchasePriceNote'), this.valueOrUndefined(source, 'unitBackDiscount', source.unitBackDiscount ? conversions.toBigNumber : null), this.valueOrUndefined(source, 'unitBackDiscountNote'), this.valueOrUndefined(source, 'vaValue', source.vaValue ? conversions.toBigNumber : null), this.valueOrUndefined(source, 'vaValueNote'));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      this.assignIfDefined(result, source, 'actionType');
      this.assignIfDefined(result, source, 'windowId');
      this.assignIfDefined(result, source, 'windowItemId');
      this.assignIfDefined(result, source, 'supplierAgreementId');
      this.assignIfDefined(result, source, 'windowTypeId');
      this.assignIfDefined(result, source, 'windowTypeNote');
      this.assignIfDefined(result, source, 'windowName');
      this.assignIfDefined(result, source, 'windowNameNote');
      this.assignIfDefined(result, source, 'regularPrice', source.regularPrice ? conversions.fromBigNumber : null);
      this.assignIfDefined(result, source, 'regularPriceNote');
      this.assignIfDefined(result, source, 'promoPrice', source.promoPrice ? conversions.fromBigNumber : null);
      this.assignIfDefined(result, source, 'promoPriceNote');
      this.assignIfDefined(result, source, 'promoVolume', source.promoVolume ? conversions.fromBigNumber : null);
      this.assignIfDefined(result, source, 'promoVolumeNote');
      this.assignIfDefined(result, source, 'posMarginImpactTheoretical', source.posMarginImpactTheoretical ? conversions.fromBigNumber : null);
      this.assignIfDefined(result, source, 'posMarginImpactTheoreticalNote');
      this.assignIfDefined(result, source, 'posMechanics');
      this.assignIfDefined(result, source, 'posMechanicsNote');
      this.assignIfDefined(result, source, 'promoPurchasePrice', source.promoPurchasePrice ? conversions.fromBigNumber : null);
      this.assignIfDefined(result, source, 'promoPurchasePriceNote');
      this.assignIfDefined(result, source, 'unitBackDiscount', source.unitBackDiscount ? conversions.fromBigNumber : null);
      this.assignIfDefined(result, source, 'unitBackDiscountNote');
      this.assignIfDefined(result, source, 'vaValue', source.vaValue ? conversions.fromBigNumber : null);
      this.assignIfDefined(result, source, 'vaValueNote');
      return result;
    }
  }, {
    key: "assignIfDefined",
    value: function assignIfDefined(obj, source, attribute, fn) {
      if (!utils_1.Utils.isUndefined(source[attribute])) {
        obj[attribute] = source[attribute] === null ? null : fn ? fn(source[attribute]) : source[attribute];
      }
    }
  }, {
    key: "valueOrUndefined",
    value: function valueOrUndefined(source, attribute, conversion) {
      if (utils_1.Utils.isUndefined(source[attribute])) {
        return undefined;
      } else {
        return conversion ? ForecastSimulationUpdateDTO_1.ForecastSimulationUpdateDTO.schema[attribute].valueOf(conversion(source[attribute])) : ForecastSimulationUpdateDTO_1.ForecastSimulationUpdateDTO.schema[attribute].valueOfField(source);
      }
    }
  }]);

  return ForecastSimulationUpdateDTOConverterImpl;
}(ForecastSimulationUpdateDTOConverter_1.ForecastSimulationUpdateDTOConverter);

exports.ForecastSimulationUpdateDTOConverterImpl = ForecastSimulationUpdateDTOConverterImpl;